module.exports = __webpack_public_path__ + "media/images/index-hero-badge-1d3486b20eac263de9e1a5f0f8a80119.svg";